import React from "react";
import ContactUs from "../components/ContactUs";
import PageHero from "../components/PageHero";

function ContactUsPage() {
  return (
    <div className="bg-gray-50">
      <PageHero
        title="Get In Touch"
        crumb="Contact Us"
        subtitle="Let's discuss your next construction project - we're here to help"
      />
      <ContactUs />
    </div>
  );
}

export default ContactUsPage;
